import React, { FunctionComponent } from 'react'
import { getStatusView } from 'Containers/Tracks/helpers'
import { useTranslation } from 'react-i18next'
import { colors } from 'Styled/variables'
import { TrackDetailsProps } from './types'
import { Grid, Title } from './styles'

export const TrackDetails: FunctionComponent<TrackDetailsProps> = ({
  dance,
  genres,
  status,
  vocal,
}) => {
  const { t } = useTranslation()
  const { text, color } = getStatusView(status, t)

  const trackInfo = [
    {
      name: 'influencer.genres',
      values: genres.join(', '),
      color: colors.mainText,
    },
    {
      name: 'influencer.vocal',
      values: vocal.join(', '),
      color: colors.mainText,
    },
    {
      name: 'influencer.dance',
      values: dance ? t('influencer.required') : t('influencer.notRequired'),
      color: colors.mainText,
    },
    {
      name: 'influencer.status',
      values: text,
      color,
    },
  ]

  return (
    <div>
      <Title>{t('influencer.tracksDetails')}</Title>
      <Grid>
        {trackInfo.map(({ name, values, color }) => (
          <>
            <span style={{ color: colors.greyTextWhiteBg }}>{t(name)}:</span>
            <div style={{ color }}>{values}</div>
          </>
        ))}
      </Grid>
    </div>
  )
}
